var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-error-page',{attrs:{"code":"404","caption":"THIS PAGE DOESN'T EXIST!"}})}
var staticRenderFns = []

export { render, staticRenderFns }